import axios from 'axios'

export default function Updater(condition, callback) {

    axios.put(condition.url, condition.data)

    .then(res => {

        callback({
            data : res.data.info,
            message : res.data.message
        })
    })

    .catch(err => {

        callback({
            data : null,
            message : 'ERROR'
        })

    })

}




// WEBPACK FOOTER //
// ./src/controller/Updater.js